import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Chart, ChartConfiguration, ChartDataset, ChartOptions } from 'chart.js/auto';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
})
export class BarChartComponent implements AfterViewInit, OnChanges, OnDestroy {
  constructor() {}
  @ViewChild('barChartCanvas') barChartCanvas!: ElementRef<HTMLCanvasElement>;

  @Input() labels: string[] = [];
  @Input() datasets: ChartDataset<'bar'>[] = [];
  @Input() options: ChartOptions<'bar'> = {};

  public barChart: Chart<'bar'> | null = null;

  ngAfterViewInit(): void {
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.barChartCanvas) {
      return;
    }

    if (changes.labels || changes.datasets || changes.options) {
      this.renderChart();
    }
  }

  ngOnDestroy(): void {
    if (this.barChart) {
      this.barChart.destroy();
    }
  }

  private renderChart(): void {
    const labels = this.labels;
    const datasets = this.datasets;

    if (!labels.length || !datasets.length) {
      if (this.barChart) {
        this.barChart.destroy();
        this.barChart = null;
      }
      return;
    }

    const config: ChartConfiguration<'bar'> = {
      type: 'bar',
      data: {
        labels,
        datasets,
      },
      options: this.options,
    };

    if (this.barChart) {
      this.barChart.destroy();
    }

    this.barChart = new Chart(this.barChartCanvas.nativeElement, config);
  }
}
